<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <div class="row">
                    <div class="col-12">
                        <form-input v-model="query.syear" id="syear" label="學年度" type="number"></form-input>
                    </div>
                    <!--<div class="col-md col-sm-6">
                        <form-select v-model="query.semester" id="semester" label="學期">
                            <div is="option" value="">全部</div>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>-->
                </div>
            </div>
            <div class="page-border">
                <div class="row">
                    <div class="col-12">
                        <!--<b-button variant="success" @click="file('R1')">活動場數分析</b-button>-->
                        <b-button variant="success" @click="file('R2')">C5-1</b-button>
                        <b-button variant="success" @click="file('R3')">C5-2</b-button>
                        <b-button variant="success" @click="file('R4')">C5-3</b-button>
                        <b-button variant="success" @click="file('R5')">C7</b-button>
                    </div>
                </div>
            </div>
        </div>
    </page-main>
</template>

<script>
    export default {
        name: 'g1report',
        data: function () {
            return {
                query: { syear: '', semester: '' }
            }
        },
        methods: {
            file: function (action) {
                if (this.query.syear == "") {
                    this.$bvToast.toast("請選擇學年度", { title: '發生錯誤', variant: 'danger', solid: true });
                    return;
                }

                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/g1report/" + action + "?" + new URLSearchParams(this.query).toString();
                $a.click();
            }
        }
    };
</script>

<style>
</style>